import { useTranslation } from "react-i18next";
import { AuthCard } from "@/components/auth/AuthCard";
import { ConfirmHandler } from "@/components/auth/ConfirmHandler";

export function ConfirmPage() {
  const { t } = useTranslation("auth");
  return (
    <AuthCard title={t("confirm.title")}>
      <ConfirmHandler />
    </AuthCard>
  );
}
